import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAdmin } from '../context/AdminContext';
import { formatFecha } from '../utils/fecha';

import { API } from '../config/api';
const TIPOS = ['Persona Jurídica', 'Persona Física'];
const PROVINCIAS = ['San José','Alajuela','Cartago','Heredia','Guanacaste','Puntarenas','Limón'];

const EMPTY = {
  id_cliente:'', tipo_cliente:'Persona Jurídica', nombre:'', contacto:'',
  telefono:'', telefono_facturas:'', correo:'', correo_facturas:'',
  correo_2:'', correo_3:'', provincia:'', canton:'', distrito:'',
  direccion:'', actividad_economica:'', activo: 1
};

const inputStyle = {
  padding:'8px 12px', border:'1px solid #e0e0e0', borderRadius:'8px',
  fontSize:'13px', outline:'none', width:'100%', boxSizing:'border-box',
  fontFamily:'Segoe UI, sans-serif'
};

const tipoBadge = (tipo) => {
  const s = tipo === 'Persona Física'
    ? { background:'#EAF3DE', color:'#27500A' }
    : { background:'#e6f1fb', color:'#185FA5' };
  return <span style={{ ...s, padding:'2px 8px', borderRadius:'8px', fontSize:'11px', fontWeight:'500' }}>
    {tipo === 'Persona Física' ? 'Física' : 'Jurídica'}
  </span>;
};


function ModalEliminar({ item, onConfirm, onCancel }) {
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.35)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 }}>
      <div style={{ background:'#fff', borderRadius:'14px', padding:'28px', width:'380px' }}>
        <div style={{ width:'52px', height:'52px', background:'#FCEBEB', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px' }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6" stroke="#A32D2D" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <h3 style={{ textAlign:'center', fontSize:'16px', fontWeight:'700', color:'#1a1a1a', margin:'0 0 8px' }}>Eliminar cliente</h3>
        <p style={{ textAlign:'center', fontSize:'13px', color:'#666', margin:'0 0 20px', lineHeight:'1.5' }}>
          ¿Eliminar permanentemente a <strong>{item?.nombre}</strong>?<br/>
          Esta acción <strong>no se puede deshacer</strong>.
        </p>
        <div style={{ display:'flex', justifyContent:'flex-end', gap:'10px' }}>
          <button onClick={onCancel} style={{ padding:'8px 20px', border:'1px solid #e0e0e0', borderRadius:'8px', background:'#fff', cursor:'pointer', fontSize:'13px' }}>Cancelar</button>
          <button onClick={onConfirm} style={{ padding:'8px 20px', background:'#A32D2D', color:'#fff', border:'none', borderRadius:'8px', fontSize:'13px', fontWeight:'600', cursor:'pointer' }}>Sí, eliminar</button>
        </div>
      </div>
    </div>
  );
}

export default function Clientes() {
  const isAdmin = useAdmin();
  const [lista, setLista]                 = useState([]);
  const [vistaActivos, setVistaActivos]   = useState(true);
  const [filtro, setFiltro]               = useState('');
  const [modal, setModal]                 = useState(false);
  const [detalle, setDetalle]             = useState(null);
  const [form, setForm]                   = useState(EMPTY);
  const [editando, setEditando]           = useState(false);
  const [cargando, setCargando]           = useState(true);
  const [guardando, setGuardando]         = useState(false);
  const [error, setError]                 = useState('');
  const [modalEliminar, setModalEliminar] = useState(null);

  useEffect(() => { cargar(); }, []);

  const cargar = async () => {
    setCargando(true);
    try {
      const [resActivos, resInactivos] = await Promise.all([
        axios.get(`${API}/clientes`),
        axios.get(`${API}/clientes?inactivos=true`)
      ]);
      setLista([
        ...resActivos.data.map(c => ({ ...c, activo: true })),
        ...resInactivos.data.map(c => ({ ...c, activo: false }))
      ]);
    } catch (e) { console.error(e); }
    setCargando(false);
  };

  const activos   = lista.filter(c => c.activo);
  const inactivos = lista.filter(c => !c.activo);
  const fuente    = vistaActivos ? activos : inactivos;

  const filtrados = fuente.filter(c =>
    [c.nombre, c.id_cliente, c.provincia, c.contacto, c.actividad_economica, c.correo]
      .some(v => (v || '').toLowerCase().includes(filtro.toLowerCase()))
  );

  const stats = {
    total:     activos.length,
    juridica:  activos.filter(c => c.tipo_cliente === 'Persona Jurídica').length,
    fisica:    activos.filter(c => c.tipo_cliente === 'Persona Física').length,
    inactivos: inactivos.length,
  };

  const cerrarModal = () => {
    if (window.confirm('¿Salir sin guardar? Los cambios se perderán.')) {
      setModal(false);
      setError('');
    }
  };
  const abrirNuevo  = () => { setForm(EMPTY); setEditando(false); setError(''); setModal(true); };
  const abrirEditar = (c) => { setForm({ ...EMPTY, ...c }); setEditando(true); setError(''); setModal(true); setDetalle(null); };

  const guardar = async () => {
    if (!form.nombre?.trim())     { setError('El Nombre es obligatorio.'); return; }
    if (!form.id_cliente?.trim()) { setError('El ID Cliente es obligatorio.'); return; }
    setGuardando(true); setError('');
    try {
      if (editando) await axios.put(`${API}/clientes?id=${form.id}`, form);
      else          await axios.post(`${API}/clientes`, form);
      setModal(false);
      await cargar();
    } catch (e) { setError('Error al guardar: ' + (e.response?.data?.error || e.message)); }
    finally { setGuardando(false); }
  };

  const desactivar = async (c) => {
    if (!window.confirm(`¿Desactivar a ${c.nombre}? Podrá reactivarlo más adelante.`)) return;
    try {
      await axios.delete(`${API}/clientes?id=${c.id}`);
      setDetalle(null);
      setVistaActivos(true);
      await cargar();
    } catch (e) { console.error(e); }
  };

  const reactivar = async (c) => {
    if (!window.confirm(`¿Reactivar a ${c.nombre}?`)) return;
    try {
      await axios.put(`${API}/clientes?id=${c.id}`, { reactivar: true });
      setDetalle(null);
      setVistaActivos(true);
      await cargar();
    } catch (e) { console.error(e); }
  };

  const confirmarEliminar = async () => {
    if (!modalEliminar) return;
    try {
      await axios.delete(`${API}/clientes?id=${modalEliminar.id}&hard=true`);
      setModalEliminar(null); setDetalle(null); await cargar();
    } catch (e) { alert('Error al eliminar: ' + (e.response?.data?.error || e.message)); }
  };

  const campo = (label, key, tipo = 'text', opciones = null) => (
    <div style={{ display:'flex', flexDirection:'column', gap:'4px' }}>
      <label style={{ fontSize:'10px', color:'#888', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px' }}>{label}</label>
      {opciones
        ? <select value={form[key]||''} onChange={e => setForm({...form,[key]:e.target.value})} style={inputStyle}>
            <option value=''>— Seleccionar —</option>
            {opciones.map(o => <option key={o} value={o}>{o}</option>)}
          </select>
        : <input type={tipo} value={form[key]||''} onChange={e => setForm({...form,[key]:e.target.value})} style={inputStyle}/>
      }
    </div>
  );

  const seccion = (label) => (
    <div style={{ gridColumn:'1/-1', fontSize:'11px', fontWeight:'700', color:'#012E40', textTransform:'uppercase', letterSpacing:'0.7px', padding:'8px 0 6px', borderBottom:'2px solid #e8e8e8', marginTop:'8px' }}>{label}</div>
  );

  const campoVer = (label, valor) => (
    <div>
      <div style={{ fontSize:'10px', color:'#aaa', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'3px' }}>{label}</div>
      <div style={{ fontSize:'13px', color: valor ? '#012E40' : '#ccc', fontWeight: valor ? '500' : '400' }}>{valor || '—'}</div>
    </div>
  );

  const hrSep = () => <hr style={{ border:'none', borderTop:'1px solid #f0f0f0', margin:'14px 0' }}/>;

  return (
    <div style={{ padding:'24px', fontFamily:'Segoe UI, sans-serif', maxWidth:'1200px' }}>

      {/* Header */}
      <div style={{ background:'#012E40', borderRadius:'12px', padding:'16px 20px', marginBottom:'20px', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
        <div style={{ display:'flex', alignItems:'center', gap:'14px' }}>
          <span style={{ color:'#fff', fontSize:'17px', fontWeight:'700' }}>Clientes</span>
          <div style={{ display:'flex', background:'rgba(255,255,255,0.1)', borderRadius:'20px', padding:'2px' }}>
            <button onClick={() => { setVistaActivos(true); setFiltro(''); setDetalle(null); }}
              style={{ padding:'4px 16px', border:'none', borderRadius:'20px', fontSize:'12px', fontWeight:'600', cursor:'pointer',
                background: vistaActivos ? '#fff' : 'transparent',
                color:      vistaActivos ? '#012E40' : 'rgba(255,255,255,0.6)' }}>
              Activos ({activos.length})
            </button>
            <button onClick={() => { setVistaActivos(false); setFiltro(''); setDetalle(null); }}
              style={{ padding:'4px 16px', border:'none', borderRadius:'20px', fontSize:'12px', fontWeight:'600', cursor:'pointer',
                background: !vistaActivos ? '#fff' : 'transparent',
                color:      !vistaActivos ? '#A32D2D' : 'rgba(255,255,255,0.6)' }}>
              Inactivos ({inactivos.length})
            </button>
          </div>
        </div>
        <button onClick={abrirNuevo} style={{ padding:'8px 16px', background:'#87B749', color:'#fff', border:'none', borderRadius:'8px', fontSize:'13px', fontWeight:'600', cursor:'pointer' }}>
          + Nuevo cliente
        </button>
      </div>

      {/* Stats */}
      {vistaActivos && (
        <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:'12px', marginBottom:'20px' }}>
          {[
            { label:'Total activos',   valor: stats.total,     color:'#012E40' },
            { label:'Persona Jurídica', valor: stats.juridica,  color:'#185FA5' },
            { label:'Persona Física',  valor: stats.fisica,    color:'#27500A' },
            { label:'Inactivos',       valor: stats.inactivos, color:'#A32D2D' },
          ].map(s => (
            <div key={s.label} style={{ background:'#fff', border:'1px solid #e8e8e8', borderRadius:'10px', padding:'14px 18px' }}>
              <div style={{ fontSize:'11px', color:'#888', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px' }}>{s.label}</div>
              <div style={{ fontSize:'26px', fontWeight:'700', color: s.color, marginTop:'4px' }}>{s.valor}</div>
            </div>
          ))}
        </div>
      )}

      {/* Buscador */}
      <div style={{ marginBottom:'16px', position:'relative' }}>
        <svg style={{ position:'absolute', left:'12px', top:'50%', transform:'translateY(-50%)', pointerEvents:'none' }} width="16" height="16" viewBox="0 0 20 20" fill="none">
          <circle cx="9" cy="9" r="6" stroke="#aaa" strokeWidth="1.5"/>
          <path d="M15 15l-3-3" stroke="#aaa" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
        <input value={filtro} onChange={e => setFiltro(e.target.value)}
          placeholder={`Buscar ${vistaActivos ? 'clientes activos' : 'clientes inactivos'}...`}
          style={{ ...inputStyle, paddingLeft:'38px', borderRadius:'10px', background:'#fff' }}/>
      </div>

      {/* Tabla activos */}
      {vistaActivos && (
        <div style={{ background:'#fff', border:'1px solid #e8e8e8', borderRadius:'12px', overflow:'hidden', marginBottom:'16px' }}>
          {cargando ? (
            <div style={{ padding:'40px', textAlign:'center', color:'#888' }}>Cargando...</div>
          ) : filtrados.length === 0 ? (
            <div style={{ padding:'40px', textAlign:'center', color:'#bbb' }}>No se encontraron clientes.</div>
          ) : (
            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'13px' }}>
              <thead>
                <tr style={{ background:'#f8f9fa' }}>
                  {['Nombre','ID Cliente','Tipo','Contacto','Provincia','Proyectos','Acciones'].map(h => (
                    <th key={h} style={{ padding:'11px 14px', textAlign:'left', color:'#888', fontWeight:'600', fontSize:'11px', textTransform:'uppercase', letterSpacing:'0.5px', borderBottom:'1px solid #eee' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtrados.map(c => (
                  <tr key={c.id} style={{ borderBottom:'1px solid #f3f3f3', cursor:'pointer' }}
                    onMouseEnter={e => e.currentTarget.style.background='#fafafa'}
                    onMouseLeave={e => e.currentTarget.style.background='transparent'}>
                    <td style={{ padding:'11px 14px', fontWeight:'600', color:'#1a1a1a' }}
                      onClick={() => setDetalle(detalle?.id === c.id ? null : c)}>
                      {c.nombre}
                    </td>
                    <td style={{ padding:'11px 14px', color:'#555' }}>{c.id_cliente}</td>
                    <td style={{ padding:'11px 14px' }}>{tipoBadge(c.tipo_cliente)}</td>
                    <td style={{ padding:'11px 14px', color:'#555' }}>{c.contacto || '—'}</td>
                    <td style={{ padding:'11px 14px', color:'#555' }}>{c.provincia || '—'}</td>
                    <td style={{ padding:'11px 14px' }}>
                      {c.total_proyectos > 0
                        ? <span style={{ background:'#f0f7e8', color:'#3B6D11', padding:'2px 8px', borderRadius:'8px', fontSize:'11px', fontWeight:'600' }}>{c.total_proyectos} proy.</span>
                        : <span style={{ color:'#ccc', fontSize:'12px' }}>—</span>
                      }
                    </td>
                    <td style={{ padding:'11px 14px' }}>
                      <div style={{ display:'flex', gap:'6px' }}>
                        <button onClick={() => abrirEditar(c)}
                          style={{ padding:'4px 12px', background:'none', border:'1px solid #ddd', borderRadius:'6px', fontSize:'12px', cursor:'pointer', color:'#555' }}>
                          Editar
                        </button>
                        {isAdmin && (
                          <button onClick={() => setModalEliminar(c)}
                            style={{ padding:'4px 12px', background:'none', border:'1px solid #fcc', borderRadius:'6px', fontSize:'12px', cursor:'pointer', color:'#A32D2D' }}>
                            Eliminar
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* Tabla inactivos */}
      {!vistaActivos && (
        <div style={{ background:'#fff', border:'1px solid #e8e8e8', borderRadius:'12px', overflow:'hidden', borderTop:'3px solid #f5c6c6', marginBottom:'16px' }}>
          <div style={{ background:'#fdf3f3', padding:'10px 16px', display:'flex', alignItems:'center', justifyContent:'space-between', borderBottom:'1px solid #f5c6c6' }}>
            <span style={{ fontSize:'12px', color:'#A32D2D', fontWeight:'600' }}>
              Clientes inactivos — {inactivos.length} registro{inactivos.length !== 1 ? 's' : ''}
            </span>
            <span style={{ fontSize:'11px', color:'#888' }}>
              {isAdmin ? 'Podés reactivar o eliminar permanentemente' : 'Solo admins pueden eliminar'}
            </span>
          </div>
          {cargando ? (
            <div style={{ padding:'40px', textAlign:'center', color:'#888' }}>Cargando...</div>
          ) : filtrados.length === 0 ? (
            <div style={{ padding:'40px', textAlign:'center', color:'#bbb' }}>
              {inactivos.length === 0 ? 'No hay clientes inactivos.' : 'No se encontraron resultados.'}
            </div>
          ) : (
            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'13px' }}>
              <thead>
                <tr style={{ background:'#fdf8f8' }}>
                  {['Nombre','ID Cliente','Tipo','Provincia','Acciones'].map(h => (
                    <th key={h} style={{ padding:'11px 14px', textAlign:'left', color:'#bbb', fontWeight:'600', fontSize:'11px', textTransform:'uppercase', letterSpacing:'0.5px', borderBottom:'1px solid #f0e8e8' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtrados.map(c => (
                  <tr key={c.id} style={{ borderBottom:'1px solid #faf0f0', opacity:0.8 }}>
                    <td style={{ padding:'11px 14px', color:'#999', fontWeight:'500', textDecoration:'line-through' }}>{c.nombre}</td>
                    <td style={{ padding:'11px 14px', color:'#bbb' }}>{c.id_cliente}</td>
                    <td style={{ padding:'11px 14px' }}>{tipoBadge(c.tipo_cliente)}</td>
                    <td style={{ padding:'11px 14px', color:'#bbb' }}>{c.provincia || '—'}</td>
                    <td style={{ padding:'11px 14px' }}>
                      <div style={{ display:'flex', gap:'6px' }}>
                        <button onClick={() => reactivar(c)}
                          style={{ padding:'4px 14px', background:'#012E40', color:'#fff', border:'none', borderRadius:'6px', fontSize:'12px', fontWeight:'600', cursor:'pointer' }}>
                          Reactivar
                        </button>
                        {isAdmin && (
                          <button onClick={() => setModalEliminar(c)}
                            style={{ padding:'4px 12px', background:'none', border:'1px solid #fcc', borderRadius:'6px', fontSize:'12px', cursor:'pointer', color:'#A32D2D' }}>
                            Eliminar
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* Modal Ver */}
      {detalle && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.4)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000, padding:'20px' }}>
          <div style={{ background:'#fff', borderRadius:'16px', width:'100%', maxWidth:'720px', maxHeight:'90vh', display:'flex', flexDirection:'column', overflow:'hidden' }}>

            {/* Contenido scrolleable */}
            <div style={{ overflowY:'auto', padding:'28px' }}>

              {/* Título y botones */}
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:'16px' }}>
                <div>
                  <div style={{ fontSize:'20px', fontWeight:'700', color:'#012E40', marginBottom:'8px' }}>{detalle.nombre}</div>
                  <div style={{ display:'flex', gap:'6px' }}>
                    {tipoBadge(detalle.tipo_cliente)}
                    <span style={{
                      background: detalle.activo ? '#e8f4e4' : '#fdecea',
                      color:      detalle.activo ? '#2d6a2d' : '#d32f2f',
                      padding:'2px 8px', borderRadius:'8px', fontSize:'11px', fontWeight:'500'
                    }}>{detalle.activo ? 'Activo' : 'Inactivo'}</span>
                  </div>
                </div>
                <div style={{ display:'flex', gap:'8px', alignItems:'center' }}>
                  <button onClick={() => abrirEditar(detalle)}
                    style={{ padding:'7px 16px', background:'none', border:'1px solid #ddd', borderRadius:'8px', fontSize:'13px', cursor:'pointer', color:'#555' }}>
                    Editar
                  </button>
                  {detalle.activo
                    ? <button onClick={() => desactivar(detalle)}
                        style={{ padding:'7px 16px', background:'none', border:'1px solid #ddd', borderRadius:'8px', fontSize:'13px', cursor:'pointer', color:'#555' }}>
                        Desactivar
                      </button>
                    : <button onClick={() => reactivar(detalle)}
                        style={{ padding:'7px 16px', background:'none', border:'1px solid #ddd', borderRadius:'8px', fontSize:'13px', cursor:'pointer', color:'#555' }}>
                        Activar
                      </button>
                  }
                  {isAdmin && (
                    <button onClick={() => setModalEliminar(detalle)}
                      style={{ padding:'7px 16px', background:'none', border:'1px solid #fcc', borderRadius:'8px', fontSize:'13px', cursor:'pointer', color:'#A32D2D' }}>
                      Eliminar
                    </button>
                  )}
                  <button onClick={() => setDetalle(null)}
                    style={{ background:'none', border:'none', fontSize:'22px', cursor:'pointer', color:'#aaa', lineHeight:1 }}>
                    ×
                  </button>
                </div>
              </div>

              {hrSep()}

              {/* Info general */}
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:'14px 24px' }}>
                {campoVer('ID Cliente', detalle.id_cliente)}
                {campoVer('Contacto', detalle.contacto)}
                {campoVer('Teléfono', detalle.telefono)}
                {campoVer('Teléfono Facturas', detalle.telefono_facturas)}
                {campoVer('Actividad Económica', detalle.actividad_economica)}
                {campoVer('Fecha de Registro', formatFecha(detalle.fecha_registro))}
              </div>

              {hrSep()}

              {/* Correos */}
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'14px 24px' }}>
                {campoVer('Correo principal', detalle.correo)}
                {campoVer('Correo Facturas', detalle.correo_facturas)}
                {campoVer('Correo 2', detalle.correo_2)}
                {campoVer('Correo 3', detalle.correo_3)}
              </div>

              {hrSep()}

              {/* Ubicación */}
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr 1fr', gap:'14px 24px' }}>
                {campoVer('Provincia', detalle.provincia)}
                {campoVer('Cantón', detalle.canton)}
                {campoVer('Distrito', detalle.distrito)}
                <div style={{ gridColumn:'1/-1' }}>
                  {campoVer('Dirección exacta', detalle.direccion)}
                </div>
              </div>

              {/* Proyectos */}
              <div style={{ background:'#f0f7e8', border:'1px solid #b8dfc8', borderRadius:'8px', padding:'12px 16px', display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:'16px' }}>
                <div>
                  <div style={{ fontSize:'10px', color:'#3B6D11', fontWeight:'700', textTransform:'uppercase', letterSpacing:'0.5px' }}>Proyectos</div>
                  <div style={{ fontSize:'24px', fontWeight:'700', color:'#012E40', marginTop:'2px' }}>
                    {detalle.total_proyectos || 0} <span style={{ fontSize:'13px', color:'#3B6D11', fontWeight:'500' }}>proyectos</span>
                  </div>
                </div>
                <span style={{ fontSize:'11px', color:'#3B6D11', fontStyle:'italic' }}>conteo desde módulo Proyectos</span>
              </div>

            </div>
          </div>
        </div>
      )}

      {/* Modal formulario */}
      {modal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.4)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000, padding:'20px' }}>
          <div style={{ background:'#fff', borderRadius:'16px', width:'100%', maxWidth:'720px', maxHeight:'90vh', display:'flex', flexDirection:'column', overflow:'hidden' }}>

            <div style={{ background:'#012E40', padding:'16px 24px', display:'flex', justifyContent:'space-between', alignItems:'center', flexShrink:0 }}>
              <span style={{ color:'#fff', fontSize:'15px', fontWeight:'700' }}>{editando ? 'Editar cliente' : 'Nuevo cliente'}</span>
              <button onClick={cerrarModal} style={{ background:'none', border:'none', color:'rgba(255,255,255,0.7)', fontSize:'22px', cursor:'pointer', lineHeight:1 }}>✕</button>
            </div>

            <div style={{ overflowY:'auto', padding:'24px', display:'flex', flexDirection:'column', gap:'4px' }}>

              {error && (
                <div style={{ background:'#FCEBEB', border:'1px solid #f5c6c6', borderRadius:'8px', padding:'10px 14px', fontSize:'13px', color:'#A32D2D', marginBottom:'8px' }}>
                  {error}
                </div>
              )}

              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'12px' }}>
                {seccion('Información general')}
                {campo('ID Cliente (cédula) *', 'id_cliente')}
                {campo('Tipo de cliente *', 'tipo_cliente', 'text', TIPOS)}
                <div style={{ gridColumn:'1/-1' }}>{campo('Nombre *', 'nombre')}</div>
                {campo('Contacto', 'contacto')}
                {campo('Actividad Económica', 'actividad_economica')}

                {seccion('Teléfonos')}
                {campo('Teléfono', 'telefono')}
                {campo('Teléfono Facturas', 'telefono_facturas')}

                {seccion('Correos electrónicos')}
                <div style={{ gridColumn:'1/-1' }}>{campo('Correo principal', 'correo', 'email')}</div>
                <div style={{ gridColumn:'1/-1' }}>{campo('Correo Facturas', 'correo_facturas', 'email')}</div>
                {campo('Correo 2', 'correo_2', 'email')}
                {campo('Correo 3', 'correo_3', 'email')}

                {seccion('Ubicación')}
                {campo('Provincia', 'provincia', 'text', PROVINCIAS)}
                {campo('Cantón', 'canton')}
                {campo('Distrito', 'distrito')}
                <div style={{ gridColumn:'1/-1' }}>{campo('Dirección exacta', 'direccion')}</div>
              </div>
            </div>

            <div style={{ padding:'16px 24px', borderTop:'1px solid #eee', display:'flex', justifyContent:'flex-end', gap:'10px', flexShrink:0 }}>
              <button onClick={cerrarModal} style={{ padding:'9px 20px', border:'1px solid #e0e0e0', borderRadius:'8px', background:'#fff', cursor:'pointer', fontSize:'13px' }}>
                Cancelar
              </button>
              <button onClick={guardar} disabled={guardando}
                style={{ padding:'9px 24px', background:'#012E40', color:'#fff', border:'none', borderRadius:'8px', fontSize:'13px', fontWeight:'600', cursor:'pointer', opacity: guardando ? 0.7 : 1 }}>
                {guardando ? 'Guardando...' : (editando ? 'Guardar cambios' : 'Crear cliente')}
              </button>
            </div>

          </div>
        </div>
      )}

      {/* Modal eliminar */}
      {modalEliminar && (
        <ModalEliminar
          item={modalEliminar}
          onConfirm={confirmarEliminar}
          onCancel={() => setModalEliminar(null)}
        />
      )}

    </div>
  );
}
